import type { FaireProductEntity } from "../../entity_types/product";

export const p_hubpvrpru4: FaireProductEntity = {
  token: "p_hubpvrpru4",
  type: "product",
  name: "Shape Up Claw Clip–Mahjong Tiles",
  brandToken: "b_9e5lkbzo3q",
  brandName: "The Darling Effect",
  imageUrl:
    "https://cdn.faire.com/fastly/f35fc54057e605988d2e7e32313dafc525c5349cd773f742f1ef0ef438eacde9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2aa13d4e9c31653cc21ebf3baf2644b158303e5a2b4fab1651c0635a153c4707.jpeg",
    "https://cdn.faire.com/fastly/266cd45ead9a0013a244b01607fd24a1afce3ee2b8c7c1037cca08b685ee0acf.jpeg",
    "https://cdn.faire.com/fastly/7880f589598f66d859ad9213161f6bebcbd1e6d5c05a0536996041dd7215d593.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Thoughtfully created to merchandise beautifully with our Let's Play: Mahjong Collection.\n\nThis claw clip features fun, playful shapes that bring a cheerful touch to your hairstyle without being too bold. It holds your hair comfortably and securely, making styling quick and effortless. The rounded edges and soft curves give it a friendly, cute look that pairs easily with different outfits. It’s a lighthearted accessory made to brighten your routine.\n\n• Durable claw clips in playful, eye-catching shapes\n• Strong grip keeps hair securely in place\n• Lightweight construction for all-day comfort\n• Perfect for quick updos, half-ups, and everyday styling\n\nWARNING: Cancer and Reproductive Harm - www.P65Warnings.ca.gov",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:45.254Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
